export const ItemTypes = {
  SEMESTER: 'semester'
};